import { render, staticRenderFns } from "./ButtonSubmitSquare.vue?vue&type=template&id=7bf7493e&scoped=true&lang=pug&"
import script from "./ButtonSubmitSquare.vue?vue&type=script&lang=ts&"
export * from "./ButtonSubmitSquare.vue?vue&type=script&lang=ts&"
import style0 from "./ButtonSubmitSquare.vue?vue&type=style&index=0&id=7bf7493e&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf7493e",
  null
  
)

export default component.exports